export const T = {
  en_GB: {
    // The locale this table is for — the member lines format "{rep} ({role})" with it.
    locale: "en_GB",
    verdictPassed: "Suitable",
    verdictFailed: "Not suitable",
    verdictIncomplete: "Incomplete",
    answerQuestions: "Answer questions",
    editAnswers: "Edit answers",
    viewAnswers: "View answers",
    notAnswered: "Not answered",
    // QL-505 (G3 follow-up) — questionnaire line status, mirroring the quiz's
    // quizPassed/quizNotPassed pair.
    questionnairePassed: "Passed",
    questionnaireNotPassed: "Not passed",
    startQuiz: "Start quiz",
    starting: "Starting...",
    retry: "Retry",
    retryWithRemaining: (n: number) => `Retry (${n} left)`,
    retryAvailableOn: (date: string) => `Retry available ${date}`,
    quizPassed: "Suitable",
    quizNotPassed: "Not suitable",
    quizNotCompleted: "Not completed",
    noAttemptsRemaining: "No attempts remaining",
    quizLabel: "Knowledge quiz",
    questionnaireLabel: "Questionnaire",
    recordedExternally: "Recorded externally",
    externalPassed: "Passed elsewhere",
    externalFailed: "Failed elsewhere",
    retakeHere: "Take here instead",
    // QL-505 — per-member group rendering
    memberCountPassed: (passed: number, total: number) => `${passed} of ${total} passed`,
    expandMembers: "Show members",
    collapseMembers: "Hide members",
    // QL-654 — a client with 2+ representatives: every representative answers for themselves.
    expandRepresentatives: "Show representatives",
    collapseRepresentatives: "Hide representatives",
  },
  nb_NO: {
    locale: "nb_NO",
    verdictPassed: "Egnet",
    verdictFailed: "Ikke egnet",
    verdictIncomplete: "Ufullstendig",
    answerQuestions: "Besvar spørsmål",
    editAnswers: "Rediger svar",
    viewAnswers: "Se svar",
    notAnswered: "Ikke besvart",
    questionnairePassed: "Bestått",
    questionnaireNotPassed: "Ikke bestått",
    startQuiz: "Start quiz",
    starting: "Starter...",
    retry: "Prøv igjen",
    retryWithRemaining: (n: number) => `Prøv igjen (${n} igjen)`,
    retryAvailableOn: (date: string) => `Nytt forsøk ${date}`,
    quizPassed: "Egnet",
    quizNotPassed: "Ikke egnet",
    quizNotCompleted: "Ikke fullført",
    noAttemptsRemaining: "Ingen forsøk igjen",
    quizLabel: "Kunnskapsquiz",
    questionnaireLabel: "Spørreskjema",
    recordedExternally: "Registrert eksternt",
    externalPassed: "Bestått eksternt",
    externalFailed: "Ikke bestått eksternt",
    retakeHere: "Ta den her i stedet",
    memberCountPassed: (passed: number, total: number) => `${passed} av ${total} bestått`,
    expandMembers: "Vis medlemmer",
    collapseMembers: "Skjul medlemmer",
    expandRepresentatives: "Vis representanter",
    collapseRepresentatives: "Skjul representanter",
  },
} as const;
